import { VerticalContainer } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DropDownItemContainer: FunctionComponent<Props> = ({
    children,
    className = '',
    isActive = false,
    onClick,
    testId = TEST_ID
}) => {
    const activeStyles = isActive ? styles.active : '';

    return (
        <VerticalContainer
            className={`${className} ${styles.dropDownItemContainer} ${activeStyles}`}
            onClick={onClick}
            testId={testId}>
            {children}
        </VerticalContainer>
    );
};

export default DropDownItemContainer;
